import { API } from 'actions/actionTypes';
import settings from 'settings';
import REDUCER_KEY from './reducer.keys';

const { APP_CONFIG } = settings;

const actionIsValid = (state, data) => data.timestamp >= state.timestamp;

const getInitialState = (type) => {
  let state = {};

  switch (type) {
  case 'list':
    state = {
      timestamp: 0,
      inFlight: false,
      isDirty: false,
      data: {
        results: [],
        count: 0
      },
      params: {
        page: 0,
        pageSize: APP_CONFIG.defaultTablePageSize,
        filters: [],
        sorted: []
      },
      meta: {
        totalPages: 0
      },
      error: {
        message: '',
        allErrors: [],
        fieldErrors: [],
        nonFieldErrors: []
      }
    };
    break;

  case 'item':
    state = {
      timestamp: 0,
      inFlight: false,
      data: {},
      error: {
        message: '',
        allErrors: [],
        fieldErrors: [],
        nonFieldErrors: []
      }
    };
    break;
  default:
    break;
  }

  return state;
};

// initalise initialState
const apiInitialState = {};
Object.keys(REDUCER_KEY)
  .forEach((item) => {
    apiInitialState[REDUCER_KEY[item].key] = getInitialState(REDUCER_KEY[item].type);
  });

const requestInFlight = (prevState, action) => {
  const { reducer, params } = action;
  const timestamp = Date.now();

  switch (REDUCER_KEY[reducer.key].type) {
  case 'list': {
    const nextState = {
      ...prevState,
      ...{
        timestamp,
        inFlight: true,
        params,
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
      }
    };
    if (actionIsValid(prevState, nextState)) {
      return nextState;
    }
    return prevState;
  }
  case 'item': {
    const nextState = {
      ...prevState,
      ...{
        timestamp,
        inFlight: true,
        params,
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
      }
    };
    if (actionIsValid(prevState, nextState)) {
      return nextState;
    }
    return prevState;
  }
  default:
    return prevState;
  }
};

const requestSuccess = (prevState, action) => {
  const { reducer, data } = action;
  const timestamp = Date.now();
  switch (REDUCER_KEY[reducer.key].type) {
  case 'list': {
    const nextState = {
      ...prevState,
      timestamp,
        inFlight: false,
        isDirty: false,
        data,
        meta: {
          totalPages: data.count ? Math.ceil(data.count / prevState.params.pageSize) : 1
        },
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
};
    if (actionIsValid(prevState, nextState)) {
      return nextState;
    }
    return prevState;
  }
  case 'item': {
    const nextState = {
      ...prevState,
      timestamp,
        inFlight: false,
        data,
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
};
    if (actionIsValid(prevState, nextState)) {
      return nextState;
    }
    return prevState;
  }
  default:
    return prevState;
  }
};

const requestFailed = (prevState, action) => {
  const { reducer, error } = action;

  switch (REDUCER_KEY[reducer.key].type) {
  case 'list': {
    const nextState = {
      ...prevState,
      ...{
        inFlight: false,
        isDirty: false,
        error
      }
    };
    return nextState;
  }
  case 'item': {
    const nextState = {
      ...prevState,
      ...{
        inFlight: false,
        error
      }
    };
    return nextState;
  }
  default:
    return prevState;
  }
};

const requestReset = (prevState, action) => {
  const { reducer } = action;
  const nextState = getInitialState(REDUCER_KEY[reducer.key].type);

  switch (REDUCER_KEY[reducer.key].type) {
  case 'list':
    return nextState;

  case 'item':
    return nextState;

  default:
    return prevState;
  }
};

const requestClear = (prevState, action) => {
  const { reducer } = action;

  switch (REDUCER_KEY[reducer.key].type) {
  case 'list': {
    const nextState = {
      ...prevState,
      ...{
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
      }
    };
    return nextState;
  }

  case 'item': {
    const nextState = {
      ...prevState,
      ...{
        error: {
          message: '',
          allErrors: [],
          fieldErrors: [],
          nonFieldErrors: []
        }
      }
    };
    return nextState;
  }

  default:
    return prevState;
  }
};

const requestDirty = (prevState, action) => {
  const { reducer } = action;
  const timestamp = Date.now();
  switch (REDUCER_KEY[reducer.key].type) {
  case 'list': {
    const nextState = {
      ...prevState,
      ...{
        timestamp,
        isDirty: true
      }
    };
    if (actionIsValid(prevState, nextState)) {
      return nextState;
    }
    return prevState;
  }

  case 'item': {
    return prevState;
  }

  default:
    return prevState;
  }
};

const api = (state = apiInitialState, action) => {
  const { reducer } = action;

  switch (action.type) {
  case API.REQUEST_IN_FLIGHT: {
    // ------ Mark Inflight = true ------
    const apiState = {};
    apiState[reducer.key] = requestInFlight(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  case API.REQUEST_SUCCESS: {
    // ------ Return fetched data ------
    const apiState = {};
    apiState[reducer.key] = requestSuccess(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  case API.REQUEST_FAILED: {
    // ------ Return error ------
    const apiState = {};
    apiState[reducer.key] = requestFailed(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  case API.RESET: {
    // ------ Reset object state ------
    const apiState = {};
    apiState[reducer.key] = requestReset(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  case API.CLEAR_ERROR: {
    // ------ Clear the object error state ------
    const apiState = {};
    apiState[reducer.key] = requestClear(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  case API.DIRTY: {
    // ------ Clear the object error state ------
    const apiState = {};
    apiState[reducer.key] = requestDirty(state[reducer.key], action);
    return { ...state, ...apiState };
  }
  default: {
    return state;
  }
  }
};

export default api;
